import { ListItem, NumberedList, Link, UnorderedList, StrongText } from '@entur/typography';
import * as React from 'react';
export default {
  ListItem,
  NumberedList,
  Link,
  UnorderedList,
  StrongText,
  React
};